/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/no-duplicated-branches */
/* eslint-disable sonarjs/cognitive-complexity */
import { Bias, UpdateViewField, hub } from "./hub";
import { TVContext } from "./hub/context";
import { SmpaTFInfo } from "./smpa/smpainfo"
import { InfoBuilder } from "./smpa/infobox"
import { markTools } from "./smpa/tools";

export class SmpaTool {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	private tools: markTools[] = [];
	lastData: Map<string, SmpaTFInfo> = null;
	lastDataTf: string;
	infoBuilder: InfoBuilder;
	d: TVContext;
	markTools: markTools;
	constructor(tvdata: TVContext, infoBuilder: InfoBuilder) {
		this.infoBuilder = infoBuilder;
		this.d = tvdata;
		this.markTools = new markTools(this.d);
		this.tools.push(this.markTools);
		this.updateView()
	}
	onViewPortChanged() {
		this.markTools.onViewPortChanged();
	}
	updateView(init = false, field = UpdateViewField.Some) {
		let rebuild = false;
		if (this.markTools.updateView(init, field))
			rebuild = true;
		if (rebuild)
			this.build(true);
		//else
		//	this.onViewPortChanged();
	}


	buildFrom(tf: string, mis: Map<string, SmpaTFInfo>) {
		this.lastData = mis;
		this.lastDataTf = tf;
		this.build(false);
	}
	clear() {
		this.lastData = null;
		this.markTools.clear();
	}
	private build(viewUpdate: boolean) { 
		const mi = this.lastData?.get(this.lastDataTf);
		let bias: boolean = null;
		let biasType = this.d.bias;
		if (biasType == Bias.Both)
			biasType = hub.bias;
		switch (biasType) {
			case Bias.Bull:
				bias = true;
				break;
			case Bias.Bear:
				bias = false;
				break;
		}

		this.markTools.build(mi, bias, viewUpdate);
		this.buildInfo(bias);
		if (mi)
			this.d.tv.activeChart().getSeries().bringToFront();

		this.markTools.buildTopMost(mi);
	}

	private buildInfo(bias: boolean) {
		if (!this.infoBuilder)
			return;
		this.infoBuilder.build(this.markTools, this.lastDataTf, this.lastData, bias);
	}
}
